<template>
  <div class="d-flex flex-column lh-base">
    <span>{{ name }}</span>
    <span v-if="description" class="text-muted fs-12">{{ description }}</span>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  params: {
    type: Object,
    default: () => ({}),
  },
})

const name = computed(() => props.params?.data?.name ?? '')
const description = computed(() => props.params?.data?.description ?? '')
</script>
